import { Component, OnInit, Renderer2, ChangeDetectorRef } from '@angular/core';
import { NguCarouselConfig } from '@ngu/carousel';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {

  carouselConfigHome: NguCarouselConfig = {
    grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
    slide: 1,
    speed: 900,
    load: 3,
    interval: {timing: 5000, initialDelay: 1500},
    loop: true,
    touch: true,
    velocity: 0.2
  }
  carouselItemsHome = ['homeImg1', 'homeImg2', 'homeImg3', 'homeImg4', 'homeImg5'];

  constructor(private renderer: Renderer2,private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.renderer.addClass(document.body, 'backgroundHome')

  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'backgroundHome');
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

}
